import React, { useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import ErrorIcon from "@mui/icons-material/Report";
import History from "@mui/icons-material/History";
import { useLocation } from "react-router";

export const MyError = ({ error, resetErrorBoundary, ...rest }) => {
  const { pathname } = useLocation();
  const originalPathname = useRef(pathname);
  const navigate = useNavigate();
  useEffect(() => {
    if (pathname !== originalPathname.current) {
      resetErrorBoundary();
    }
  }, [pathname, resetErrorBoundary]);

  return (
    <div>
      <h1>
        <ErrorIcon /> 문제가 발생했습니다.{" "}
      </h1>
      <div>클라이언트 오류가 발생하여 요청을 완료할 수 없습니다.</div>
      {process.env.NODE_ENV !== "production" && error && (
        <details>
          <h2>{error?.message || String(error)}</h2>
        </details>
      )}
      <div>
        <Button
          variant="contained"
          startIcon={<History />}
          onClick={() => navigate(-1)}
        >
          Back
        </Button>
      </div>
    </div>
  );
};
